'use client';

import { usePathname } from 'next/navigation';
import { langFromPathname, type Lang } from '../routes/routesConfig';

/**
 * Drop-in replacement for the old App.tsx `useLanguage()` context.
 *
 * The old context had no provider in the Next.js app, so every component that
 * imported `useLanguage` from '../../App' received the default value
 * (`language: 'en'`) — which made language-dependent rendering (e.g. the
 * customer-story card, localized links) show English on every locale.
 *
 * This hook derives the language from the URL instead, so it is always correct
 * and needs no provider.
 */
export const useLanguage = (): { language: Lang; setLanguage: (l: string) => void } => {
  const pathname = usePathname() || '/';
  return { language: langFromPathname(pathname), setLanguage: () => {} };
};

export default useLanguage;
